import { Button, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { PageAnchorElement, pageAnchors } from 'components/page_detail'

export const BookDetailStartClubCallout = () => {
  const { colors } = useTheme()

  const openDeeplink = () => {
    const link = 'https://links.fable.co/create-a-club'
    window.open(link, '_blank')
  }

  return (
    <PageAnchorElement id={pageAnchors.startClub.id}>
      <div
        className={css`
          max-width: 445px;
        `}
      >
        <Text tag="h2" type="header" sizing="XS" color={colors.uiGraphite}>
          Start a Book Club
        </Text>
        <Text
          className={css`
            margin: 24px 0;
          `}
          type="body"
          sizing="M"
          color={colors.uiGraphiteLight}
        >
          Start a public or private book club with this book on the Fable app
          today!
        </Text>
        <Button width="100%" onClick={openDeeplink} outline>
          Start a Book Club with this Book
        </Button>
      </div>
    </PageAnchorElement>
  )
}
